<template>
  <svg
    t="1745908665224"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="9019"
    width="200"
    height="200"
  >
    <path
      d="M104.9 233.1v557.8H919V233.1H104.9z m715.2 46L512 484.4 203.9 279.1h616.2zM150.9 744.9V299L512 539.6 873.1 299v445.9H150.9z"
      p-id="9020"
    />
  </svg>
</template>
